import complaintController from "../../../controllers/ComplaintController/controller";
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
export default {
    name : 'SimpleTable',
    data(){
        return {
            isRecaptchaVisible: false,
            isRecaptchaVerified: false,
            recaptchaToken: null,
            complaintList: [],
            currentPage: 1,
            apiUrl: 'https://s3.ap-southeast-1.amazonaws.com/cache.fli.id/dev/cms/complaint_proof/',
            pageSize: 10,
            sizes: [1,5,10,20],
            totalPages: 0,
            totalComplaint: 0,
            buktiName: '',
            buktiUrl: '',
            searchQuery: '',
            complaint: {
                id: '',
                name_complainer: '',
                email: '',
                no_hp: '',
                subject: '',
                deskripsi: '',
                files: '',
                bukti: '',
                status: '',
                created_by: '',
                created_by_name: '',
                created_on:''
            },
            selectedComplaint: {
                updated_by: '',
                updated_by_name: '',
            }
        }
    },
    computed: {
        filteredComplaint(){
            return this.complaintList.filter((complaint) => {
                return complaint.name_complainer.toLowerCase().includes(this.searchQuery.toLowerCase())
            })
        },
        pages(){
            return Math.ceil(this.totalComplaint / this.pageSize);
        },
        displayedPages() {
            const range = 1;
            let start = Math.max(this.currentPage - range, 1);
            let end = Math.min(this.currentPage + range, this.pages);
    
            // Jika kurang dari 3 halaman, sesuaikan
            if (end - start < 2) {
            if (start === 1) {
                end = Math.min(3, this.pages);
            } else if (end === this.pages) {
                start = Math.max(this.pages - 2, 1);
            }
            }
    
            const pages = [];
            for (let i = start; i <= end; i++) {
            pages.push(i);
            }
            return pages;
        },
        showStartEllipsis() {
            return this.displayedPages[0] > 1;
        },
        showEndEllipsis() {
            return this.displayedPages[this.displayedPages.length - 1] < this.pages;
        },
    },
    watch:{
        searchQuery:{
            handler: 'getComplaint',
            immediate: true
        }
    },
    methods: {
        user(){
            const user = localStorage.getItem('user');
            const id = JSON.parse(user).mst_employee_id;
            this.complaint.created_by = id;
            this.selectedComplaint.updated_by = id;
            const name = JSON.parse(user).mst_employee_name;
            this.complaint.created_by_name = name;
            this.selectedComplaint.updated_by_name = name;
        },
        showRecaptcha() {
          this.isRecaptchaVisible = true;
          this.$nextTick(() => {
            window.grecaptcha.render(document.querySelector('.g-recaptcha'), {
              sitekey: "6LcPGP8qAAAAAHhi2i81rKfnV-OsQAN7NvXrbDIR",
              callback: this.onRecaptchaSuccess
            });
          });
        },
        onRecaptchaSuccess(response) {
          console.log("reCAPTCHA verified:", response);
          this.isRecaptchaVerified = true;
          this.recaptchaToken = response;
        },

        showModal(type, id) {
            this.user();
            const complaint = this.complaintList.find(complaint => complaint.id === id);
            if (complaint) {
                this.complaint = complaint;
                
                const modal = document.getElementById(type === 'edit' ? 'editComplaint' : 'detailComplaint');
                
                modal.style.display = 'block';
                requestAnimationFrame(() => {
                modal.classList.add('show');
                });
                
                document.body.classList.add('modal-open');
                
                const backdrop = document.createElement('div');
                backdrop.classList.add('modal-backdrop', 'fade');
                document.body.appendChild(backdrop);
                
                requestAnimationFrame(() => {
                backdrop.classList.add('show');
                });
            }
        },
        closeModal() {
          const modalIds = ['tambahComplaint', 'editComplaint', 'detailComplaint'];
          modalIds.forEach(id => {
            const modal = document.getElementById(id);
            if (modal && modal.classList.contains('show')) {
              modal.classList.remove('show');
              setTimeout(() => {
                modal.style.display = 'none';
              }, 300);
            }
          });
        
          // Hapus backdrop
          const backdrops = document.querySelectorAll('.modal-backdrop');
          backdrops.forEach(backdrop => {
            backdrop.classList.remove('show');
            setTimeout(() => {
              if (backdrop.parentNode) {
                backdrop.parentNode.removeChild(backdrop);
              }
            }, 300);
          });
        
          // Hapus kelas atau atribut yang mengunci scroll pada body
          const body = document.body;
          body.classList.remove('modal-open');
          body.style.overflow = ''; // Menghapus properti overflow jika ada
          this.getComplaint();
          this.resetForm();
          this.user();
        },    
        resetForm() {
            this.buktiName = 'Pilih Bukti';
            this.buktiUrl = '';
            this.complaint.name_complainer = '';
            this.complaint.email = '';
            this.complaint.no_hp = '';
            this.complaint.subject = '';
            this.complaint.deskripsi = '';
        },
        changePage(page) {
            if (page > 0 && page <= this.pages) {
                this.currentPage = page;
                this.getComplaint();
            }
        },
        async handleStatusChange() {
            const selectedStatus = this.complaint.status;
            switch (selectedStatus) {
            case '4':
                console.log("Status: Re-Assign");
                break;
            case '3':
                console.log("Status: Start");
                break;
            case '2':
                console.log("Status: In Progress");
                break;
            case '1':
                console.log("Status: Done");
                break;
            case '0':
                console.log("Status: Rejected");
                break;
            default:
                console.warn("Status tidak dikenal");
            }
        },
        async handleFileUpload(event) {
            try {
                const file = event.target.files[0];
                if (!file) {
                    alert('Silahkan pilih file');
                    return;
                }
        
                this.buktiName = file.name;
        
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.buktiUrl = e.target.result;
                    this.complaint.bukti = e.target.result;
                };
                reader.readAsDataURL(file);
                this.complaint.files = file;
        
                // Validasi tipe file (opsional)
                const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
                if (!allowedTypes.includes(file.type)) {
                    alert('Hanya file gambar/pdf yang diperbolehkan');
                    return;
                }
        
            } catch (error) {
                console.error('Error uploading file:', error);
                alert('Gagal mengunggah file');
            }
        },        
        async getComplaint() {
            try {
                const response = await complaintController.getComplaint(this.searchQuery, this.currentPage, this.pageSize);
                this.complaintList = response.data;
                this.totalComplaint = response.total;
                this.totalAllComplaint();
            } catch (error) {
                console.error('Error fetching complaints:', error);
            }
        },
        async totalAllComplaint(search) {
            try {
                const sanitizedSearch = search && search.trim() !== '' ? search : null;
                const response = await complaintController.totalAllComplaint(sanitizedSearch);
                this.totalComplaint = response;
            } catch (error) {
                console.error('Error fetching complaints:', error);
            }
        },
        async addComplaint() {
            try {
                if (!this.recaptchaToken){
                  Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Silahkan verifikasi reCAPTCHA',
                    timer: 1500
                  })
                  return;
                }
                const tipe = 'Admin';
                const formData = new FormData();
                formData.append('name', this.complaint.name_complainer);
                formData.append('name_company', this.complaint.name_company);
                formData.append('email', this.complaint.email);
                formData.append('phone', this.complaint.no_hp);
                formData.append('subject', this.complaint.subject);
                formData.append('message', this.complaint.deskripsi);
                formData.append('proof', this.complaint.files);
                formData.append('tipe', tipe);
                formData.append('token', this.recaptchaToken);
                const now = new Date();
                this.complaint.created_on = now.toISOString().slice(0, 19).replace('T', ' ');
                formData.append('created_on', this.complaint.created_on);
                for (const [key, value] of formData.entries()) {
                    console.log(key, value);
                }
                await complaintController.addComplaint(formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                Swal.fire({
                    icon: 'success',
                    title: 'Complaint berhasil ditambahkan',
                    showConfirmButton: false,
                    timer: 1500
                })
                this.closeModal();
                this.resetForm();
                this.getComplaint();
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Complaint gagal ditambahkan',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        },
        async updateComplaint() {
            try{
                const id = this.complaint.id;
                const status = this.complaint.status;
                const updated_by = this.selectedComplaint.updated_by;
                const updated_by_name = this.selectedComplaint.updated_by_name;
                const now = new Date()
                const updated_on = now.toISOString().slice(0,19).replace('T', ' ');   
                if (!id || !status || !updated_by || !updated_by_name) {
                    throw new Error('Isi semua field!!');
                }  
                const update = {
                    id: id,
                    status: status,
                    updated_by: updated_by,
                    updated_by_name: updated_by_name,
                    updated_on: updated_on
                }
                await complaintController.updateComplaint(update);
                Swal.fire({
                    icon: 'success',
                    title: 'Complaint berhasil diperbaharui',
                    showConfirmButton: false,
                    timer: 1500
                })
                this.closeModal();
                this.resetForm();
                this.getComplaint();
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Complaint gagal diperbaharui',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        },
        async downloadComplaintList(){
            const response = await complaintController.downloadComplaintList();
            // Konversi data ke worksheet dan buat file Excel
            const worksheet = XLSX.utils.json_to_sheet(response);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Complaint");
            // Ekspor file
            XLSX.writeFile(workbook, "Complaint List.xlsx");
        }
    }
}